import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "grid two" }
const _hoisted_3 = { class: "grid two" }
const _hoisted_4 = { class: "section" }
const _hoisted_5 = {
  class: "upload-card",
  "element-loading-text": "上传中...",
  "element-loading-background": "rgba(255,255,255,0.6)"
}
const _hoisted_6 = { class: "upload-icon" }
const _hoisted_7 = { class: "works-grid" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "footer-actions" }

import { ref, reactive, computed, watch, onMounted } from 'vue'
import { ElDialog, ElButton, ElForm, ElFormItem, ElInput, ElSelect, ElOption, ElUpload, ElMessage, ElIcon, ElCascader } from 'element-plus'
import { uploadfiles } from '@/api/plugin'
import { Upload, Close } from '@element-plus/icons-vue'
import { businessApply, uploadImage, getDesignerApplyDict } from '@/api/match'
//@ts-ignore
import areaData from '@/common/area.json'

export default /*@__PURE__*/_defineComponent({
  __name: 'DesignerApplyDialog',
  props: {
    visible: { type: Boolean }
  },
  emits: ['update:visible', 'save', 'submit'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const innerVisible = computed({ get: () => props.visible, set: v => emit('update:visible', v) })
const formRef = ref()
const form = reactive({ name: '', domain: '', region: [] as Array<string | number>, years: '', bio: '' })
const rules = {
  name: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
  domain: [{ required: true, message: '请选择专业领域', trigger: 'change' }],
  region: [{ required: true, message: '请选择所在地', trigger: 'change' }],
  years: [{ required: true, message: '请选择从业年限', trigger: 'change' }],
  bio: [{ required: true, message: '请输入个人简介', trigger: 'blur' }]
}
const uploadRef = ref()
const workUploading = ref(false)
const fileList = ref<Array<{ url: string, serverUrl?: string, name: string, uid?: string | number, raw: File }>>([])
const beforeWorkUpload = (file: File) => {
  const okType = (file.type && file.type.startsWith('image/')) || /\.(png|jpe?g|webp|gif|bmp|svg)$/i.test(file.name || '')
  if (!okType) { ElMessage.error('仅支持图片格式'); return false }
  return true
}
const handleWorkUpload = async (option: any) => {
  workUploading.value = true
  try {
    const raw: File = option?.file?.raw || option?.file
    const fd = new FormData()
    fd.append('file', raw, raw?.name || 'file')
    const res = await uploadImage(fd)
    const url = res?.data?.data?.url || res?.data?.data?.[0]?.url || ''
    option?.onSuccess?.({ url }, option?.file)
  } catch (e) {
    option?.onError?.(e)
    ElMessage.error('上传失败')
  } finally {
    workUploading.value = false
  }
}
const onWorkSuccess = (res: any, file: any) => {
  const raw: File = file?.raw || file
  if (!raw) return
  const uid = file?.uid || raw.name
  if (fileList.value.find(f => f.uid === uid || f.name === raw.name)) return
  const serverUrl = res?.url || ''
  const url = file?.url || URL.createObjectURL(raw)
  fileList.value.push({ url, serverUrl, name: raw.name, uid, raw })
}
const onRemove = (_: any, file: any) => {
  const uid = file?.uid || file?.name
  const idx = fileList.value.findIndex(f => f.uid === uid || f.name === file?.name)
  if (idx >= 0) {
    URL.revokeObjectURL(fileList.value[idx].url)
    fileList.value.splice(idx, 1)
  }
}
const onAddClick = () => {
  try {
    const input = uploadRef.value?.$el?.querySelector('input[type=file]')
    input && input.click()
  } catch { }
}
const removeWork = (idx: number) => {
  const it = fileList.value[idx]
  if (!it) return
  try { if (it.url && String(it.url).startsWith('blob:')) URL.revokeObjectURL(it.url) } catch { }
  fileList.value.splice(idx, 1)
}
const regionOptions = ref<any[]>([])
const regionRef = ref()
const loadRegionOptions = () => {
  regionOptions.value = areaData
}
watch(innerVisible, (v) => { if (v) loadRegionOptions() })
const onCancel = () => { emit('update:visible', false) }
const onSave = () => { emit('save', { ...form, works: fileList.value }) }
const onSubmit = () => {
  console.log(fileList.value.map(f => f.serverUrl || ''))
  formRef.value?.validate((valid: boolean) => {
    if (valid) {
      let regionPath: string[] = []
      try { const node = regionRef.value?.getCheckedNodes?.()[0]; regionPath = Array.isArray(node?.pathLabels) ? node.pathLabels : [] } catch { }
      const codes = Array.isArray(form.region) ? form.region : []
      const city_code = String(codes[1] ?? codes[0] ?? '')
      const city_name = String(regionPath[1] ?? regionPath[0] ?? '')
      const majorItem = professionalOptions.value.find((d: any) => d.id === form.domain)
      const yearItem = experienceOptions.value.find((d: any) => d.id === form.years)
      const piece = fileList.value.map(f => f.serverUrl || '').filter(Boolean).join(',')
      const params = {
        user_type: 3,
        customer_name: form.name,
        piece,
        city_code,
        city_name,
        address: '',
        major: (majorItem as any)?.value || '',
        major_dict_id: form.domain,
        year_dict_id: form.years,
        year_range: (yearItem as any)?.value || '',
        introduce: form.bio,
        origin_type: 2
      }; (async () => {
        const res = await businessApply(params)
        if (res?.data?.code === 200) {
          ElMessage.success('提交成功')
          window.location.reload()
          // emit('update:visible', false)
        } else {
          ElMessage.error(res?.data?.msg || '提交失败')
        }
      })()
    }
  })
}
onMounted(() => {
  loadRegionOptions()
  getopt()
})
const professionalOptions = ref([])
const experienceOptions = ref([])
const getopt = async () => {
  let po = await getDesignerApplyDict({ parent_id: '46' })
  let eo = await getDesignerApplyDict({ parent_id: '43' })
  professionalOptions.value = po?.data?.data.list || []
  experienceOptions.value = eo?.data?.data.list || []
}

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(ElDialog), {
    modelValue: innerVisible.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((innerVisible).value = $event)),
    title: "设计师入驻申请",
    width: "860px",
    "align-center": "",
    class: "designer-dialog"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_unref(ElButton), { onClick: onCancel }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(ElButton), {
          type: "primary",
          onClick: onSubmit
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createTextVNode("提交申请", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "hint" }, "请填写以下信息完成设计师入驻申请，标有 * 的为必填项。提交后我们将在 3-5 个工作日内核您的申请，请保持联系畅通", -1)),
      _createVNode(_unref(ElForm), {
        ref_key: "formRef",
        ref: formRef,
        model: form,
        rules: rules,
        "label-position": "top",
        class: "form"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "section-title" }, "基本信息", -1)),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(ElFormItem), {
                label: "设计师姓名 *",
                prop: "name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElInput), {
                    modelValue: form.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event)),
                    placeholder: "请输入真实姓名"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(ElFormItem), {
                label: "专业领域 *",
                prop: "domain"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElSelect), {
                    modelValue: form.domain,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.domain) = $event)),
                    placeholder: "请选择专业领域"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(professionalOptions.value, (d) => {
                        return (_openBlock(), _createBlock(_unref(ElOption), {
                          key: d.id,
                          label: d.value,
                          value: d.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(ElFormItem), {
                label: "所在地 *",
                prop: "region"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElCascader), {
                    ref_key: "regionRef",
                    ref: regionRef,
                    modelValue: form.region,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.region) = $event)),
                    options: regionOptions.value,
                    style: {"width":"100%"},
                    props: { value: 'code', label: 'name', children: 'children', emitPath: true },
                    filterable: "",
                    placeholder: "请选择省/市/区"
                  }, {
                    label: _withCtx(({ node, data }) => [
                      _createTextVNode(_toDisplayString(data.name) + " " + _toDisplayString(node), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options"])
                ]),
                _: 1
              }),
              _createVNode(_unref(ElFormItem), {
                label: "从业年限 *",
                prop: "years"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElSelect), {
                    modelValue: form.years,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.years) = $event)),
                    placeholder: "请选择从业年限"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(experienceOptions.value, (d) => {
                        return (_openBlock(), _createBlock(_unref(ElOption), {
                          key: d.id,
                          label: d.value,
                          value: d.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createVNode(_unref(ElFormItem), {
              label: "个人简介 *",
              prop: "bio"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  modelValue: form.bio,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.bio) = $event)),
                  type: "textarea",
                  rows: 6,
                  maxlength: "800",
                  "show-word-limit": "",
                  placeholder: "请简要介绍您的专业背景、擅长风格、代表作品等"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "section-title" }, "代表作品", -1)),
            _createVNode(_unref(ElUpload), {
              ref_key: "uploadRef",
              ref: uploadRef,
              class: "uploader",
              drag: "",
              "show-file-list": false,
              multiple: "",
              accept: "image/*",
              "before-upload": beforeWorkUpload,
              "http-request": handleWorkUpload,
              "on-success": onWorkSuccess
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(ElIcon), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Upload))
                      ]),
                      _: 1
                    })
                  ]),
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "upload-text-main" }, "点击上传或拖放作品图片至此处", -1)),
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "upload-text-sub" }, "支持常见图片格式（PNG/JPG/JPEG/WebP/GIF/BMP/SVG），支持多选", -1))
                ])), [
                  [_directive_loading, workUploading.value]
                ])
              ]),
              _: 1
            }, 512),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (f, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: f.uid || idx,
                  class: "works-item"
                }, [
                  _createElementVNode("img", {
                    src: f.url,
                    class: "works-img"
                  }, null, 8, _hoisted_8),
                  _createElementVNode("div", {
                    class: "remove-btn",
                    title: "删除",
                    onClick: ($event: any) => (removeWork(idx))
                  }, [
                    _createVNode(_unref(ElIcon), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Close))
                      ]),
                      _: 1
                    })
                  ], 8, _hoisted_9)
                ]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})